export default "__VITE_ASSET__b80e2f2b__"